import { render, staticRenderFns } from "./acvitityPrice.vue?vue&type=template&id=4156c8b7&"
import script from "./acvitityPrice.vue?vue&type=script&lang=js&"
export * from "./acvitityPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports